import { Outlet } from 'react-router-dom';
import { ReactElement } from 'react';
import PublicRoute from 'app/modules/Auth/PublicRoute';

const PublicPages = (): ReactElement => {
  return (
    <PublicRoute>
      <Outlet />
    </PublicRoute>
  );
};

export default PublicPages;
